<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >
    <a
      v-if="slug && slug === 'comm-server'"
      :href="`${constants.commServiceUrl}/rkt/login/${accessToken}`"
      target="_blank"
      class="flex items-center"
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
      <feather-icon
        icon="ArrowUpRightIcon"
        class="ml-2"
        svgClasses="w-5 h-5"
        style="color: #999"
      ></feather-icon>
    </a>

    <router-link
      tabindex="-1"
      v-else-if="to"
      exact
      :class="[{ 'router-link-active': activeLink }]"
      :to="to"
      :target="target"
    >
      <!-- when the cast is running  -->
      <vs-row
        v-if="
          castRunningBoardsName.includes(boardName) &&
          castInstalledBoardsName.includes(boardName) &&
          !(
            roomRunningBoardsName.includes(boardName) &&
            roomInstalledBoardsName.includes(boardName)
          ) &&
          featherIcon
        "
        class="w-8 mr-3 relative left-0"
      >
        <object
          type="image/svg+xml"
          :data="require(`@/assets/images/user-dashboard/Cast.svg`)"
        >
          <svg src="../../../../assets/images/user-dashboard/Cast.svg"></svg>
        </object>
      </vs-row>
      <!-- when room is running  -->
      <vs-row
        v-else-if="
          roomRunningBoardsName.includes(boardName) &&
          roomInstalledBoardsName.includes(boardName) &&
          !(
            castRunningBoardsName.includes(boardName) &&
            castInstalledBoardsName.includes(boardName)
          ) &&
          featherIcon
        "
        class="w-8 mr-3 relative left-0"
      >
        <object
          type="image/svg+xml"
          :data="require(`@/assets/images/user-dashboard/Room.svg`)"
        >
          <img src="../../../../assets/images/user-dashboard/Room.svg" />
        </object>
      </vs-row>

      <vs-row
        v-else-if="
          roomRunningBoardsName.includes(boardName) &&
          roomInstalledBoardsName.includes(boardName) &&
          castRunningBoardsName.includes(boardName) &&
          castInstalledBoardsName.includes(boardName) &&
          featherIcon
        "
        class="w-8 h-8 mr-3 relative left-0"
      >
        <object
          type="image/svg+xml"
          :data="
            require(`@/assets/images/user-dashboard/${this.currentAnimation}`)
          "
        >
          <img
            class="transition-all"
            src=""
            v-bind="
              `../../../../assets/images/user-dashboard/${this.currentAnimation}`
            "
          />
        </object>
      </vs-row>
      <vs-icon
        v-else-if="!featherIcon"
        color="white"
        size="30px"
        :icon-pack="iconPack"
        :icon="icon"
      />
      <img
        class="mr-4 w-6 h-6"
        v-else-if="icon === 'CustomIcon' && featherIcon"
        :class="{ 'w-3 h-3': iconSmall, 'active-board-icon': activeLink }"
        src="@/assets/images/navbar/board.png"
        alt=""
      />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </router-link>

    <a v-else :target="target" :href="href" tabindex="-1">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
      <slot />
    </a>
  </div>
</template>

<script>
import constants from "@/constants.js";

export default {
  name: "v-nav-menu-item",
  props: {
    routeName: { type: String, default: "user-home" },
    icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
    boardName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      constants,
      currentAnimation: "Room.svg",
      interval: null,
    };
  },
  created() {
    if (this.interval == null) {
      this.interval = setInterval(this.toggleTimer, 3000);
    }
  },
  methods: {
    toggleTimer() {
      if (this.currentAnimation == "Room.svg") {
        this.currentAnimation = "Cast.svg";
      } else {
        this.currentAnimation = "Room.svg";
      }
    },
  },
  computed: {
    activeLink() {
      return this.to == this.$route.path ||
        (this.$route.meta.parent == this.slug && this.to)
        ? true
        : false;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    isCastRunning() {
      return this.$store.state.videowiki.isCastRunning;
    },
    castInstalledBoardsName() {
      return this.$store.state.videowiki.castInstalledBoardsName;
    },
    castRunningBoardsName() {
      return this.$store.state.videowiki.castRunningBoardsName;
    },
    roomRunningBoardsName() {
      return this.$store.state.videowiki.roomRunningBoardsName;
    },
    roomInstalledBoardsName() {
      return this.$store.state.videowiki.roomInstalledBoardsName;
    },
    isRoomRunning() {
      return this.$store.state.videowiki.isRoomRunning;
    },
  },
};
</script>

<style scoped>
svg::before {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  cursor: pointer;
  width: 2rem;
}
.active-board-icon {
  filter: brightness(0) saturate(100%) invert(71%) sepia(94%) saturate(372%)
    hue-rotate(346deg) brightness(103%) contrast(90%);
}
</style>
